<script>
    import NumberInput from '../../NumberInput.svelte';

    export let data = 0;
    export let onChange = () => {};
    export let row = null;
    export let min = 0;
    export let max = 99999;
    export let id = '';
    export let key = '';

    function handleColumnChange(event) {
        onChange(event, row);
    }
</script>

<NumberInput 
    {id}
    {key}
    bind:value={data} 
    bind:isValid={row.fieldValidations[key].isValid}
    bind:errors={row.fieldValidations[key].errors}
    on:change={handleColumnChange}
    object={row}
    {min}
    {max}/>